var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"td-email flex items-center space-x-2 justify-start"},[_c('vk-icon',{attrs:{"icon":"mail"}}),_c('span',[_vm._v(_vm._s(_vm.model))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }